import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'dskhome-footer-address',
  templateUrl: './footer-address.component.html',
  styleUrls: ['./footer-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterAddressComponent {}
